"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PFBError = exports.ErrorCodesPipelineFeeBump = void 0;
const error_1 = require("../../../../stellar-plus/error");
const transaction_1 = require("../../../../stellar-plus/error/helpers/transaction");
var ErrorCodesPipelineFeeBump;
(function (ErrorCodesPipelineFeeBump) {
    // PFB0 General
    ErrorCodesPipelineFeeBump["PFB001"] = "PFB001";
})(ErrorCodesPipelineFeeBump || (exports.ErrorCodesPipelineFeeBump = ErrorCodesPipelineFeeBump = {}));
const couldntWrapFeeBump = (error, conveyorBeltErrorMeta, innerTransaction) => {
    return new error_1.StellarPlusError({
        code: ErrorCodesPipelineFeeBump.PFB001,
        message: 'Error building fee bump transaction!',
        source: 'PipelineFeeBump',
        details: `An issue occurred while building the fee bump transaction:'${error.message}'- Refer to the meta section for more details.`,
        meta: {
            error,
            transactionData: (0, transaction_1.extractTransactionData)(innerTransaction),
            conveyorBeltErrorMeta,
        },
    });
};
exports.PFBError = {
    couldntWrapFeeBump,
};
